import { institutionResponsible } from "../../../../config/index.js";
import * as React from 'react';
export default {
  institutionResponsible,
  React
};